import AppRoutes from './routing/AppRoutes';

function App() {
  return (
    <AppRoutes />
  );
}

export default App;
